export default "__VITE_ASSET__9310e7a8__"